import { Component, OnInit } from '@angular/core';
import { IToast, ToastService } from 'codex-lib';
import { NewEnvelopeSteps } from 'src/app/enum/new-envelope-steps';
import { Responsible } from 'src/app/model/responsible';
import { MainEnvelopeComponent } from 'src/app/main-envelope/main-envelope.component';
import { SurvicateService } from 'src/app/services/survicate.service';
import { TranslateService } from '@ngx-translate/core';
import { NewEnvelopeService } from '../../new-envelope/new-envelope.service';
import { LanguageUtil } from 'src/app/util/language-util';
import { CPFCNPJUtil } from 'src/app/util/CPF-CNPJ-util';
import { AnalyticsService } from 'src/app/modules/google-analytics/service/analytics.service';
import { AnalyticEventClient } from 'src/app/enum/analytic-event-client.enum';
import { TrackerData } from 'src/app/modules/google-analytics/model/tracker-data.model';

@Component({
  selector: 'app-responsible-information',
  templateUrl: './responsible-information.component.html',
  styleUrls: ['./responsible-information.component.scss'],
})
export class ResponsibleInformationComponent implements OnInit {
  responsibleInformation: any;
  blankSlateSearch: any;
  responsibles: Array<Responsible> = [];
  canSendWhatsApp: boolean = false;
  isSendWhatsapp: boolean = false;
  isSignFreemium: boolean = false;

  constructor(
    private newEnvelopeService: NewEnvelopeService,
    private mainEnvelopeComponent: MainEnvelopeComponent,
    private survicateService: SurvicateService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private googleAnalitycsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.canSendWhatsApp = this.mainEnvelopeComponent.canSendWhatsApp;
    this.isSendWhatsapp = this.mainEnvelopeComponent.isSendWhatsapp;
    this.isSignFreemium = this.survicateService.isSignFree();

    this.responsibleInformation = this.newEnvelopeService.getModelData(NewEnvelopeSteps.Signatory);
    this.responsibleInformation['envelopeResponsible']?.forEach((e) => {
      e.sendWhatsApp = false;
    });

    this.responsibles = this.responsibleInformation['envelopeResponsible'] || [];
  }

  needSendWhatsapp(value: boolean, responsibleId: number) {
    this.googleAnalitycsService.sendEvent(
      new TrackerData(
        AnalyticEventClient.TK_PT_SIGNER_NEW_ENVELOPE,
        'Signer_NovEnv_Revisar_WA_ResponsavelForm',
        value ? 'Ativo' : 'Inativo'
      )
    );
    this.responsibles.find((x) => x.id === responsibleId).sendWhatsApp = value;
  }

  toastWhatsFree() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.acceptWhatsappSignFreeToast'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }

  handleToggleClick(event: Event) {
    if (!this.canSendWhatsApp && !this.isSignFreemium) {
      event.preventDefault();
      event.stopPropagation();
      this.toastCantSendWhatsapp();
    }
  }

  toastCantSendWhatsapp() {
    const toast: IToast = {
      text: this.translateService.instant('contacts.sendMessageWhatsappDisabled'),
      autoHide: true,
    };
    this.toastService.createNewToast(toast);
  }

  isShowSSN() {
    const languageId = this.newEnvelopeService.getLanguageEnvelope();
    return LanguageUtil.isCurrentLanguagePT(languageId) ? true : false;
  }

  setMaskValue(value) {
    return CPFCNPJUtil.canObfuscateCpfCnpj(CPFCNPJUtil.formatSsn(value));
  }
}
